module.exports = __webpack_public_path__ + "static/media/offline-app.fc94240d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/step-5/offline-app.png
 ** module id = 356
 ** module chunks = 0
 **/